import type { ExternalContent } from '@getmayday/vue-modules';

const logExternalContentRead = (
  content: ExternalContent,
  source: string,
  logFunction: any,
) => {
  if (!content) return;
  const { denormalizedExternalKnowledge } = content;
  const connectionType =
    denormalizedExternalKnowledge?.connectionType || 'sharepoint-deltas';
  logFunction({
    topic: 'EXTERNAL_CONTENT_READ',
    event: {
      connectionType,
      externalContentId: content.id,
      mimeType: content.mimeType,
      externalKnowledgeId: content.externalKnowledgeId,
      source,
    },
    url: window.location.href,
  });
};

export default logExternalContentRead;
